// extracted by mini-css-extract-plugin
module.exports = {"LPPage":"Backend_LPPage__i1ANi","contents":"Backend_contents__3d_jc"};